import type { FaireAdPerformancePeriodEntity } from "../../entity_types/adPerformancePeriod";

export const perfP8NrReorder202606: FaireAdPerformancePeriodEntity = {
  token: "perf_p8_nr_reorder_202606",
  type: "adPerformancePeriod",
  scope: "REORDER_MARKETPLACE",
  periodType: "RECEIPT",
  startDate: "2026-06-01",
  endDate: "2026-06-30",
  impressions: 44695,
  clicks: 698,
  adsSpendDollars: 5960,
  budgetDollars: 9000,
  salesDollars: 28582,
  bestEstimateRoas: 4.8,
  bestEstimateType: "ACTUALIZED",
  budgetUtilization: 0.66,
  reorderConversions: 81,
  dataAvailableAtDate: "2026-07-04",
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
